(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'contentPlain', {
            bindings: {
                content:               '<',
                tooltipless:           '@', // Doesn't render inline tooltips (~ saving processing power)
                headingsLevelDecrease: '<',
            },
            templateUrl:    'app/views/partials/content/content-plain.html',
            controller:     ContentPlainController,
            controllerAs:   'vm',

            renderingOptions: {
                'content-plain': {
                    inputs:    [
                        'content="::content.asset_contents"',
                        'headings-level-decrease="::customData.headingsLevelDecrease"'
                    ],
                    wrapStart: '<div class="centraliser">',
                    wrapEnd:   '</div>',
                    classes:   [ 'block' ]
                },
                'content-plain-phd': {
                    inputs:    [ 'content="::content.asset_contents"' ],
                    wrapStart: '<div class="centraliser">',
                    wrapEnd:   '</div>',
                    classes:   [ 'block' ]
                },
                'intro-subject': {
                    inputs:    [ 'content="::content.asset_contents"' ],
                    wrapStart: '<div class="centraliser">',
                    wrapEnd:   '</div>',
                    classes:   [ 'block', 'study-intro' ]
                },
                'intro-degree': {
                    inputs:    [ 'content="::content.asset_contents"' ],
                    wrapStart: '<div class="centraliser">',
                    wrapEnd:   '</div>',
                    classes:   [ 'block' ]
                },
                'intro': {
                    inputs:    [ 'content="::content.asset_contents"' ],
                    wrapStart: '<div class="centraliser">',
                    wrapEnd:   '</div>',
                    classes:   [ 'block' ]
                },
                'content-plain-warning': {
                    inputs:    [ 'content="::content.asset_contents"' ],
                    parentClasses: [ 'warning-strip' ],
                    classes:       [ 'block' ],
                    wrapStart:     '<div class="centraliser block-container">',
                    wrapEnd:       '</div>'
                }
            },

            renderingOptionsOverrides: {
                nested: {
                    'content-plain': {
                        wrapStart:     null,
                        wrapEnd:       null,
                        parentClasses: [ 'block' ],
                        classes:       null
                    },
                    'content-plain-phd': {
                        wrapStart:     null,
                        wrapEnd:       null,
                        parentClasses: [ 'block' ],
                        classes:       null
                    },
                    'content-plain-warning': {
                        wrapStart:     null,
                        wrapEnd:       null,
                        parentClasses: [ 'warning-strip', 'block-container' ]
                    }
                }
            }
        });


        /**
         * @param {Utils} Utils
         */
        function ContentPlainController( Utils ){

            // Helper members.

            /** @type {angular.IController} */
            var vm = this;

            vm.shouldTooltipify   = undefined;
            vm.shouldAutocollapse = undefined;

            /** *MUST BE* present to allow directive `collapsible` to bind to the Controller's $postLink event. */
            Utils.addGenericPostLinkTrigger( vm );


            /** @constructor */
            vm.$onInit = function() {
                // Init Controller's methods
                vm.constructAnchor = Utils.anchorConstructorFactory( vm, 'content', 'heading' );

                // Should the `tooltipification` be ommited?
                vm.shouldTooltipify = angular.isUndefined( vm.tooltipless );

                // Whether or not should the collapsing/expanding feature be turned on
                vm.shouldAutocollapse = angular.isDefined( vm.content.autoCollapse ) && vm.content.autoCollapse;

                /**
                 * 1. To decrease the heading level, the following `customData` value
                 * *MUST BE* passed to the `dynamic-block` directive:
                 *
                 *  custom-data="::{ headingsLevelDecrease: true }"
                 *
                 * 2. In `renderingOptions` block within this component, you *MUST* include following in the template's `input` to pass the `customData` through:
                 *
                 * 'headings-level-decrease="::customData.headingsLevelDecrease"'
                 */
                vm.isHeadingLevelDecreased = angular.isDefined( vm.headingsLevelDecrease ) && Boolean( vm.headingsLevelDecrease );
            }
        }


        ContentPlainController.$inject = [ 'Utils' ];
})();
